document.addEventListener("alpine:init", () => {
  // ! START
  Alpine.data("product", () => ({
    currency: "",
    product_embed: false,
    pid: "",
    has_spinoffs: false,
    so: 0,
    ot: [],
    oc: [],
    quantity: 1,
    nyp: 0.0,
    show_errors: true,
    giftcard_image: "",
    error_msg: "",
    base_price: 0,
    display_price: "$0.00",
    flkty: "",
    selectedCell: 0,

    init() {
      this.$nextTick(() => {
        if (this.product_embed) {
          // https://codepen.io/desandro/pen/ByYoKM
          this.flkty = new Flickity(".carousel-main", {
            lazyLoad: 1,
            adaptiveHeight: true,
            pageDots: true,
            on: {
              change: (index) => {
                this.selectedCell = index;
              },
            },
          });
        }
      });
    },
    // !debug
    debug(s) {
      if (this.dbg) if (window.console && window.console.log) window.console.log("[cartloom] " + s);
    },
    // !logError
    logError(str) {
      Bugsnag.notify(new Error(str));
      if (window.console && window.console.log && str)
        window.console.error("[cartloom] \n" + str.replace(/\t/g, "").trim());
    },

    spinoffBlur(price) {
      this.base_price = price;
      this.debug("spinoffBlur = " + price);
      this.calculateTotal();
    },

    numbersOnly(e) {
      const charCode = e.which ? e.which : e.keyCode;
      if (e.key === ".") return true;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105) && charCode !== 110) {
        e.preventDefault();
      }
    },

    calculateTotal() {
      //var $dl = this.$refs.form;
      this.debug("base price = " + this.base_price);
      var start = parseFloat(this.base_price);
      var add = parseFloat(0.0);
      var amt = parseFloat(0.0);
      if (isNaN(start)) {
        start = 0;
      }
      // https://gomakethings.com/es6-foreach-loops-with-vanilla-javascript/
      let choices = document.querySelectorAll("[name^=oc]");
      choices.forEach((choice) => {
        var name = choice.name || "";
        this.debug(name);
        var va,
          vn,
          v = choice.value;
        var temp = [];
        // does v exist and does it contain the semicolon delimiter
        if (v && v.indexOf(";") > -1) {
          temp = v.split(";");
          vn = temp[0];
          va = temp[1] || v; // detail amount
        }
        this.debug("name: " + name);
        this.debug("v: " + v);
        this.debug("type: " + choice.type);
        if (choice.type == "select-one") {
          amt = parseFloat(va); // get new per item amount
        } else if (choice.type == "radio" && choice.checked) {
          // radio option
          amt = parseFloat(va); // get new per item amount
        } else if (choice.type == "checkbox" && choice.checked) {
          // checkbox option
          amt = parseFloat(va); // get new per item amount
        } else if (choice.type == "text") {
          amt = 0; // text option never effects price
        }
        if (isNaN(amt)) {
          console.log("NaN amount for input: " + vn || name);
          return;
        }
        add = amt + add;
        amt = 0; // zero it out to start next loop
      });
      var tempTotal = start + add;
      if (tempTotal < 0) tempTotal = 0;
      var newtotal = tempTotal.toFixed(2);
      var newFormattedTotal = this.currencyFormat(tempTotal);
      this.display_price = newFormattedTotal;
    },
    currencyFormat(floatVal) {
      var Currency = {
        AUD: {
          dec: ".",
          grp: ",",
          sym: "$",
        }, // Australian Dollar
        BRL: {
          dec: ".",
          grp: ".",
          sym: "R",
        }, //Brazilian Real
        CAD: {
          dec: ".",
          grp: ",",
          sym: "$",
        }, // Canadian Dollar
        CHF: {
          dec: ".",
          grp: "'",
          sym: "CHF ",
        }, // Swiss Franc
        CZK: {
          dec: ",",
          grp: ".",
          sym: " CZK",
        }, // Czech Koruna
        DKK: {
          dec: ".",
          grp: ".",
          sym: " kr",
        }, //Danish Krone
        EUR: {
          dec: ",",
          grp: ".",
          sym: " &euro;",
        }, // Euro
        GBP: {
          dec: ".",
          grp: ",",
          sym: "&pound;",
        }, // GB Pound
        HKD: {
          dec: ".",
          grp: ",",
          sym: "HK$",
        }, // Hong Kong Dollar
        HUF: {
          dec: ".",
          grp: ",",
          sym: "HK$",
        }, // Hungarian Forint
        ILS: {
          dec: ".",
          grp: ",",
          sym: "$",
        }, // Israeli New Sheqel
        JPY: {
          dec: "",
          grp: ",",
          sym: "&yen;",
          noDecimals: 1,
        }, // Japanese Yen
        MYR: {
          dec: ".",
          grp: ".",
          sym: "R",
        }, // malaysian ringgit
        MXN: {
          dec: ".",
          grp: ",",
          sym: "$",
        }, // Mexican Peso
        NOK: {
          dec: ",",
          grp: ".",
          sym: " kr",
        }, // Norwegian Krone
        NZD: {
          dec: ".",
          grp: ",",
          sym: "$",
        }, // New Zealand Dollar
        PHP: {
          dec: ".",
          grp: ",",
          sym: "PhP ",
        }, // Phillippine Peso
        PLN: {
          dec: ".",
          grp: ",",
          sym: " z&#322;",
        }, // Polish Zloty
        SEK: {
          dec: ".",
          grp: " ",
          sym: " SEK",
        }, // Swedish Krona
        SGD: {
          dec: ".",
          grp: ",",
          sym: "SGD $",
        }, //Singapore Dollar
        TWD: {
          dec: ".",
          grp: ",",
          sym: "NT$ ",
          noDecimals: 1,
        }, // Taiwan New Dollar
        THB: {
          dec: ".",
          grp: ",",
          sym: "&#3647; ",
        }, // Tai Baht
        TRY: {
          dec: ",",
          grp: ".",
          sym: " TL",
        },
      };
      var val = floatVal.toFixed(2);
      var hash = Currency[this.currency] || {
        dec: ".",
        grp: ",",
        sym: "$",
      };
      if (hash.noDecimals) val = val.replace(/\..*/, "");
      val = val.replace(/\,/g, hash.grp);
      val = val.replace(/\.([\d]{0,2})$/, hash.dec + "$1");
      if (/^ /.test(hash.sym)) val = val + hash.sym;
      else val = hash.sym + val;
      return val;
    },
  }));
});
